"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var warning_1 = __importDefault(require("warning"));
var prop_types_1 = __importDefault(require("prop-types"));
var getMetadata_1 = __importDefault(require("./getMetadata"));
var getDisplayName_1 = __importDefault(require("./getDisplayName"));
var METADATA_KEY = 'layer-associations';
/**
 * A HoC to provide layer names for an associated entity.
 *
 * @param {Object} WrappedComponent The component to wrap & provide the layers for.
 * @return {Object} The wrapped component.
 */
exports.withLayers = function (layerType) { return function (WrappedComponent) {
    var WithLayers = function (props) {
        var metadata = getMetadata_1.default(props.map.getStyle(), METADATA_KEY);
        warning_1.default(metadata, "Missing layer association metadata for '" + layerType + "'.");
        warning_1.default(metadata && Array.isArray(metadata[layerType]), "Missing layer association metadata for layer '" + layerType + "'.");
        return (react_1.default.createElement(WrappedComponent, __assign({ layers: metadata && metadata[layerType] ? metadata[layerType] : [] }, props)));
    };
    WithLayers.propTypes = {
        map: prop_types_1.default.shape({
            getStyle: prop_types_1.default.func.isRequired
        }).isRequired
    };
    WithLayers.displayName = "WithLayers(" + getDisplayName_1.default(WrappedComponent) + ")";
    return react_1.default.memo(WithLayers);
}; };
exports.default = exports.withLayers;
